(() => {
  const root = document.querySelector('[data-mv-limited-offer]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const expiresAt = new Date(root.dataset.expiresAt);
  const productUrl = root.dataset.productUrl;
  const countdown = root.querySelector('[data-mv-limited-countdown]');
  const closeButtons = root.querySelectorAll('[data-mv-limited-offer-close]');
  const cta = root.querySelector('[data-mv-limited-offer-cta]');
  const storageKey = `mv-limited-offer:${root.dataset.expiresAt}`;
  let timerId;

  const emit = (name) => {
    document.dispatchEvent(
      new CustomEvent(name, {
        detail: {
          expiresAt: root.dataset.expiresAt,
          productUrl,
        },
      })
    );
  };

  const storeSeen = () => {
    try {
      window.sessionStorage.setItem(storageKey, 'shown');
    } catch (error) {
      // The offer still works when browser storage is unavailable.
    }
  };

  const wasSeen = () => {
    if (window.Shopify?.designMode) return false;
    try {
      return window.sessionStorage.getItem(storageKey) === 'shown';
    } catch (error) {
      return false;
    }
  };

  const unlockPage = () => {
    document.documentElement.classList.remove('mv-limited-offer-open', 'mv-limited-offer-pending');
    window.MarinaLimitedOfferActive = false;
    emit('marina:limited-offer:closed');
  };

  const close = () => {
    if (typeof root.close === 'function' && root.open) root.close();
    else root.removeAttribute('open');
    unlockPage();
  };

  const expire = () => {
    if (timerId) window.clearInterval(timerId);
    root.dataset.expired = 'true';
    close();
    root.remove();
    emit('marina:limited-offer:expired');
  };

  const format = (number) => String(number).padStart(2, '0');

  const updateCountdown = () => {
    const difference = expiresAt.getTime() - Date.now();
    if (difference <= 0) {
      expire();
      return false;
    }

    const values = {
      '[data-mv-days]': Math.floor(difference / 86400000),
      '[data-mv-hours]': Math.floor((difference % 86400000) / 3600000),
      '[data-mv-minutes]': Math.floor((difference % 3600000) / 60000),
      '[data-mv-seconds]': Math.floor((difference % 60000) / 1000),
    };

    Object.entries(values).forEach(([selector, value]) => {
      const field = countdown?.querySelector(selector);
      if (field) field.textContent = format(value);
    });
    return true;
  };

  const open = () => {
    if (!root.isConnected || root.dataset.expired === 'true') return;
    window.MarinaLimitedOfferActive = true;
    document.documentElement.classList.add('mv-limited-offer-open');

    if (typeof root.showModal === 'function') root.showModal();
    else root.setAttribute('open', '');

    storeSeen();
    emit('marina:limited-offer:opened');
    root.querySelector('[data-mv-limited-offer-close]')?.focus();
  };

  closeButtons.forEach((button) => button.addEventListener('click', close));

  root.addEventListener('click', (event) => {
    if (event.target === root) close();
  });

  root.addEventListener('close', unlockPage);
  root.addEventListener('cancel', () => window.setTimeout(unlockPage, 0));

  cta?.addEventListener('click', (event) => {
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const targetPath = new URL(cta.href, window.location.origin).pathname.replace(/\/$/, '');
    if (currentPath !== targetPath) return;

    event.preventDefault();
    close();
    const productArea = document.querySelector('.product__info-container, product-info, #MainContent');
    productArea?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (Number.isNaN(expiresAt.getTime()) || expiresAt.getTime() <= Date.now()) {
    expire();
    return;
  }

  if (!updateCountdown()) return;
  timerId = window.setInterval(updateCountdown, 1000);

  window.MarinaLimitedOffer = {
    expiresAt: root.dataset.expiresAt,
    productUrl,
    isActive: () => Boolean(window.MarinaLimitedOfferActive),
    open,
    close,
  };

  if (!wasSeen()) {
    window.MarinaLimitedOfferActive = true;
    document.documentElement.classList.add('mv-limited-offer-pending');
    window.setTimeout(open, 3500);
  }
})();
